module.exports = __webpack_public_path__ + "root-img2.png?90b4ee16892779a779bf446a2c9d1bac";


//////////////////
// WEBPACK FOOTER
// ./src/assets/root-img2.png
// module id = 37
// module chunks = 0